import React from 'react'
import { Typography as MuiTypography } from '@material-ui/core'
import { TypographyProps } from '@material-ui/core/Typography'
import styleOverride from './style'

const Typography: React.FC<TypographyProps> = ({ ...props }) => (
  <MuiTypography {...props} classes={styleOverride()} />
)

export default Typography
